export function calculateIMC(idade: number, peso: number, altura: number) {
  let obesite = false;
  let message = '';
  let imc = 0;
  imc = (10000 * peso) / Math.pow(altura, 2);

  if (imc > 25) {
    obesite = true;
  } else {
    obesite = false;
  }

  if (imc > 25 && imc < 30) {
    message = 'Atenção, IMC> 25: Excesso de peso';
  } else if (imc > 30) {
    message = 'Atenção, IMC> 30: Obeso';
  }

  return {
    message: message,
    obesidade: obesite,
    value: imc,
  };
}

export function calculateAll(
  genre: string,
  age: number,
  hered: any,
  sedent: any,
  obesite: any,
  pregnant: number,
  sintomas: any,
  listSintomas: any[]
) {
  let ageout = 0;
  let delta = 0;

  var c0state = sintomas;

  // sintomas imagens
  var c1state = listSintomas.find(
    (item) => item.id === 1 && item.selected === true
  )
    ? 1
    : 0;
  var c2state = listSintomas.find(
    (item) => item.id === 2 && item.selected === true
  )
    ? 1
    : 0;
  var c3state = listSintomas.find(
    (item) => item.id === 3 && item.selected === true
  )
    ? 1
    : 0;
  var c4state = listSintomas.find(
    (item) => item.id === 4 && item.selected === true
  )
    ? 1
    : 0;
  var c5state = listSintomas.find(
    (item) => item.id === 5 && item.selected === true
  )
    ? 1
    : 0;
  var c6state = listSintomas.find(
    (item) => item.id === 6 && item.selected === true
  )
    ? 1
    : 0;

  let digitage = 0;
  let digitrisk = 0;

  var c1risk = 0;
  var c2risk = 0;
  var c3risk = 0;
  var c4risk = 0;
  var c5risk = 0;

  if (genre == 'M') {
    // homme
    digitage =
      c0state * 1 +
      c1state * 2 +
      c2state * 4 +
      c3state * 8 +
      c4state * 16 +
      c5state * 32 +
      c6state * 64;

    switch (digitage) {
      case 0:
        delta = 0;
        break;
      case 1:
        delta = 6;
        break;
      case 2:
        delta = 4;
        break;
      case 3:
        delta = 12;
        break;
      case 6:
        delta = 13;
        break;
      case 7:
        delta = 14;
        break;
      case 10:
        delta = 13;
        break;
      case 11:
        delta = 13;
        break;
      case 18:
        delta = 15;
        break;
      case 19:
        delta = 15;
        break;
      case 34:
        delta = 15;
        break;
      case 35:
        delta = 15;
        break;
      case 66:
        delta = 15;
        break;
      case 67:
        delta = 15;
        break;
      case 4:
        delta = 9;
        break;
      case 5:
        delta = 13;
        break;
      case 12:
        delta = 13;
        break;
      case 13:
        delta = 13;
        break;
      case 20:
        delta = 17;
        break;
      case 21:
        delta = 17;
        break;
      case 36:
        delta = 18;
        break;
      case 37:
        delta = 18;
        break;
      case 68:
        delta = 18;
        break;
      case 69:
        delta = 18;
        break;
      case 8:
        delta = 13;
        break;
      case 9:
        delta = 13;
        break;
      case 24:
        delta = 15;
        break;
      case 25:
        delta = 15;
        break;
      case 40:
        delta = 17;
        break;
      case 41:
        delta = 17;
        break;
      case 72:
        delta = 17;
        break;
      case 73:
        delta = 17;
        break;
      case 16:
        delta = 14;
        break;
      case 17:
        delta = 14;
        break;
      case 48:
        delta = 18;
        break;
      case 49:
        delta = 18;
        break;
      case 80:
        delta = 18;
        break;
      case 81:
        delta = 18;
        break;
      case 32:
        delta = 14;
        break;
      case 33:
        delta = 14;
        break;
      case 64:
        delta = 14;
        break;
      case 65:
        delta = 14;
        break;
      case 14:
        delta = 14;
        break;
      case 15:
        delta = 14;
        break;
      case 22:
        delta = 18;
        break;
      case 23:
        delta = 18;
        break;
      case 38:
        delta = 18;
        break;
      case 39:
        delta = 18;
        break;
      case 70:
        delta = 18;
        break;
      case 71:
        delta = 18;
        break;
      case 26:
        delta = 15;
        break;
      case 27:
        delta = 15;
        break;
      case 42:
        delta = 17;
        break;
      case 43:
        delta = 17;
        break;
      case 74:
        delta = 17;
        break;
      case 75:
        delta = 17;
        break;
      case 50:
        delta = 18;
        break;
      case 51:
        delta = 18;
        break;
      case 82:
        delta = 18;
        break;
      case 83:
        delta = 18;
        break;
      case 28:
        delta = 17;
        break;
      case 29:
        delta = 17;
        break;
      case 44:
        delta = 18;
        break;
      case 45:
        delta = 18;
        break;
      case 76:
        delta = 18;
        break;
      case 77:
        delta = 18;
        break;
      case 52:
        delta = 18;
        break;
      case 53:
        delta = 18;
        break;
      case 84:
        delta = 18;
        break;
      case 85:
        delta = 18;
        break;
      case 56:
        delta = 18;
        break;
      case 57:
        delta = 18;
        break;
      case 88:
        delta = 18;
        break;
      case 89:
        delta = 18;
        break;
      case 30:
        delta = 18;
        break;
      case 31:
        delta = 18;
        break;
      case 46:
        delta = 19;
        break;
      case 47:
        delta = 19;
        break;
      case 78:
        delta = 19;
        break;
      case 79:
        delta = 19;
        break;
      case 54:
        delta = 19;
        break;
      case 55:
        delta = 19;
        break;
      case 86:
        delta = 19;
        break;
      case 87:
        delta = 19;
        break;
      case 58:
        delta = 19;
        break;
      case 59:
        delta = 19;
        break;
      case 90:
        delta = 19;
        break;
      case 91:
        delta = 19;
        break;
      case 60:
        delta = 19;
        break;
      case 61:
        delta = 19;
        break;
      case 92:
        delta = 19;
        break;
      case 93:
        delta = 19;
        break;
      case 62:
        delta = 20;
        break;
      case 63:
        delta = 20;
        break;
      case 94:
        delta = 20;
        break;
      case 95:
        delta = 20;
        break;
      case 98:
        delta = 15;
        break;
      case 99:
        delta = 15;
        break;
      case 100:
        delta = 18;
        break;
      case 101:
        delta = 18;
        break;
      case 104:
        delta = 17;
        break;
      case 105:
        delta = 17;
        break;
      case 112:
        delta = 18;
        break;
      case 113:
        delta = 18;
        break;
      case 96:
        delta = 14;
        break;
      case 97:
        delta = 14;
        break;
      case 102:
        delta = 18;
        break;
      case 103:
        delta = 18;
        break;
      case 106:
        delta = 17;
        break;
      case 107:
        delta = 17;
        break;
      case 114:
        delta = 18;
        break;
      case 115:
        delta = 18;
        break;
      case 108:
        delta = 18;
        break;
      case 109:
        delta = 18;
        break;
      case 116:
        delta = 18;
        break;
      case 117:
        delta = 18;
        break;
      case 120:
        delta = 18;
        break;
      case 121:
        delta = 18;
        break;
      case 110:
        delta = 19;
        break;
      case 111:
        delta = 19;
        break;
      case 118:
        delta = 19;
        break;
      case 119:
        delta = 19;
        break;
      case 122:
        delta = 19;
        break;
      case 123:
        delta = 19;
        break;
      case 124:
        delta = 19;
        break;
      case 125:
        delta = 19;
        break;
      case 126:
        delta = 20;
        break;
      case 127:
        delta = 20;
        break;
    }

    digitrisk = hered * 1 + sedent * 2 + obesite * 4;

    if (age < 30) {
      switch (digitrisk) {
        case 0:
          c1risk = 19;
          c2risk = 6;
          c3risk = 4;
          c4risk = 5;
          c5risk = 1;
          break;
        case 1:
          c1risk = 34;
          c2risk = 21;
          c3risk = 10;
          c4risk = 5;
          c5risk = 4;
          break;
        case 2:
          c1risk = 23;
          c2risk = 9;
          c3risk = 6;
          c4risk = 5;
          c5risk = 2;
          break;
        case 3:
          c1risk = 34;
          c2risk = 27;
          c3risk = 13;
          c4risk = 8;
          c5risk = 5;
          break;
        case 4:
          c1risk = 19;
          c2risk = 7;
          c3risk = 5;
          c4risk = 5;
          c5risk = 2;
          break;
        case 5:
          c1risk = 34;
          c2risk = 24;
          c3risk = 24;
          c4risk = 13;
          c5risk = 4;
          break;
        case 6:
          c1risk = 26;
          c2risk = 16;
          c3risk = 12;
          c4risk = 7;
          c5risk = 5;
          break;
        case 7:
          c1risk = 36;
          c2risk = 27;
          c3risk = 24;
          c4risk = 0;
          c5risk = 0;
          break;
      }
    }

    if (age >= 30 && age < 40) {
      switch (digitrisk) {
        case 0:
          c1risk = 20;
          c2risk = 12;
          c3risk = 6;
          c4risk = 5;
          c5risk = 3;
          break;
        case 1:
          c1risk = 36;
          c2risk = 34;
          c3risk = 21;
          c4risk = 11;
          c5risk = 5;
          break;
        case 2:
          c1risk = 25;
          c2risk = 13;
          c3risk = 10;
          c4risk = 5;
          c5risk = 3;
          break;
        case 3:
          c1risk = 38;
          c2risk = 35;
          c3risk = 21;
          c4risk = 11;
          c5risk = 8;
          break;
        case 4:
          c1risk = 23;
          c2risk = 13;
          c3risk = 16;
          c4risk = 6;
          c5risk = 4;
          break;
        case 5:
          c1risk = 40;
          c2risk = 40;
          c3risk = 33;
          c4risk = 18;
          c5risk = 13;
          break;
        case 6:
          c1risk = 30;
          c2risk = 18;
          c3risk = 16;
          c4risk = 9;
          c5risk = 6;
          break;
        case 7:
          c1risk = 40;
          c2risk = 40;
          c3risk = 33;
          c4risk = 24;
          c5risk = 15;
          break;
      }
    }

    if (age >= 40 && age < 50) {
      switch (digitrisk) {
        case 0:
          c1risk = 24;
          c2risk = 15;
          c3risk = 10;
          c4risk = 6;
          c5risk = 3;
          break;
        case 1:
          c1risk = 36;
          c2risk = 41;
          c3risk = 26;
          c4risk = 16;
          c5risk = 9;
          break;
        case 2:
          c1risk = 29;
          c2risk = 18;
          c3risk = 12;
          c4risk = 6;
          c5risk = 4;
          break;
        case 3:
          c1risk = 38;
          c2risk = 41;
          c3risk = 26;
          c4risk = 17;
          c5risk = 11;
          break;
        case 4:
          c1risk = 30;
          c2risk = 21;
          c3risk = 16;
          c4risk = 7;
          c5risk = 4;
          break;
        case 5:
          c1risk = 41;
          c2risk = 48;
          c3risk = 33;
          c4risk = 27;
          c5risk = 14;
          break;
        case 6:
          c1risk = 31;
          c2risk = 27;
          c3risk = 16;
          c4risk = 9;
          c5risk = 6;
          break;
        case 7:
          c1risk = 41;
          c2risk = 48;
          c3risk = 35;
          c4risk = 27;
          c5risk = 15;
          break;
      }
    }

    if (age >= 50) {
      switch (digitrisk) {
        case 0:
          c1risk = 33;
          c2risk = 24;
          c3risk = 15;
          c4risk = 6;
          c5risk = 8;
          break;
        case 1:
          c1risk = 40;
          c2risk = 48;
          c3risk = 29;
          c4risk = 22;
          c5risk = 12;
          break;
        case 2:
          c1risk = 35;
          c2risk = 30;
          c3risk = 20;
          c4risk = 12;
          c5risk = 10;
          break;
        case 3:
          c1risk = 33;
          c2risk = 24;
          c3risk = 15;
          c4risk = 11;
          c5risk = 8;
          break;
        case 4:
          c1risk = 42;
          c2risk = 51;
          c3risk = 34;
          c4risk = 30;
          c5risk = 15;
          break;
        case 5:
          c1risk = 41;
          c2risk = 49;
          c3risk = 29;
          c4risk = 26;
          c5risk = 15;
          break;
        case 6:
          c1risk = 37;
          c2risk = 35;
          c3risk = 26;
          c4risk = 18;
          c5risk = 12;
          break;
        case 7:
          c1risk = 42;
          c2risk = 54;
          c3risk = 39;
          c4risk = 33;
          c5risk = 20;
          break;
      }
    }
  }

  if (genre === 'F') {
    // femme
    digitage =
      c0state * 1 +
      c1state * 2 +
      c2state * 4 +
      c3state * 8 +
      c4state * 16 +
      c5state * 32 +
      c6state * 64;

    switch (digitage) {
      case 0:
        delta = 0;
        break;
      case 1:
        delta = 5;
        break;
      case 2:
        delta = 4;
        break;
      case 3:
        delta = 9;
        break;
      case 6:
        delta = 14;
        break;
      case 7:
        delta = 15;
        break;
      case 10:
        delta = 9;
        break;
      case 11:
        delta = 9;
        break;
      case 18:
        delta = 18;
        break;
      case 19:
        delta = 18;
        break;
      case 34:
        delta = 18;
        break;
      case 35:
        delta = 18;
        break;
      case 66:
        delta = 18;
        break;
      case 67:
        delta = 18;
        break;
      case 4:
        delta = 12;
        break;
      case 5:
        delta = 15;
        break;
      case 12:
        delta = 15;
        break;
      case 13:
        delta = 15;
        break;
      case 20:
        delta = 19;
        break;
      case 21:
        delta = 19;
        break;
      case 36:
        delta = 19;
        break;
      case 37:
        delta = 19;
        break;
      case 68:
        delta = 19;
        break;
      case 69:
        delta = 19;
        break;
      case 8:
        delta = 9;
        break;
      case 9:
        delta = 9;
        break;
      case 24:
        delta = 18;
        break;
      case 25:
        delta = 18;
        break;
      case 40:
        delta = 18;
        break;
      case 41:
        delta = 18;
        break;
      case 72:
        delta = 18;
        break;
      case 73:
        delta = 18;
        break;
      case 16:
        delta = 16;
        break;
      case 17:
        delta = 16;
        break;
      case 48:
        delta = 19;
        break;
      case 49:
        delta = 19;
        break;
      case 80:
        delta = 19;
        break;
      case 81:
        delta = 19;
        break;
      case 32:
        delta = 18;
        break;
      case 33:
        delta = 18;
        break;
      case 64:
        delta = 18;
        break;
      case 65:
        delta = 18;
        break;
      case 14:
        delta = 15;
        break;
      case 15:
        delta = 15;
        break;
      case 22:
        delta = 21;
        break;
      case 23:
        delta = 21;
        break;
      case 38:
        delta = 21;
        break;
      case 39:
        delta = 21;
        break;
      case 70:
        delta = 21;
        break;
      case 71:
        delta = 21;
        break;
      case 26:
        delta = 20;
        break;
      case 27:
        delta = 20;
        break;
      case 42:
        delta = 20;
        break;
      case 43:
        delta = 20;
        break;
      case 74:
        delta = 20;
        break;
      case 75:
        delta = 20;
        break;
      case 50:
        delta = 21;
        break;
      case 51:
        delta = 21;
        break;
      case 82:
        delta = 21;
        break;
      case 83:
        delta = 21;
        break;
      case 28:
        delta = 20;
        break;
      case 29:
        delta = 20;
        break;
      case 44:
        delta = 21;
        break;
      case 45:
        delta = 21;
        break;
      case 76:
        delta = 21;
        break;
      case 77:
        delta = 21;
        break;
      case 52:
        delta = 21;
        break;
      case 53:
        delta = 21;
        break;
      case 84:
        delta = 21;
        break;
      case 85:
        delta = 21;
        break;
      case 56:
        delta = 22;
        break;
      case 57:
        delta = 22;
        break;
      case 88:
        delta = 22;
        break;
      case 89:
        delta = 22;
        break;
      case 30:
        delta = 22;
        break;
      case 31:
        delta = 22;
        break;
      case 46:
        delta = 22;
        break;
      case 47:
        delta = 22;
        break;
      case 78:
        delta = 22;
        break;
      case 79:
        delta = 22;
        break;
      case 54:
        delta = 22;
        break;
      case 55:
        delta = 22;
        break;
      case 86:
        delta = 22;
        break;
      case 87:
        delta = 22;
        break;
      case 58:
        delta = 23;
        break;
      case 59:
        delta = 23;
        break;
      case 90:
        delta = 23;
        break;
      case 91:
        delta = 23;
        break;
      case 60:
        delta = 23;
        break;
      case 61:
        delta = 23;
        break;
      case 92:
        delta = 23;
        break;
      case 93:
        delta = 23;
        break;
      case 62:
        delta = 25;
        break;
      case 63:
        delta = 25;
        break;
      case 94:
        delta = 25;
        break;
      case 95:
        delta = 25;
        break;
      case 98:
        delta = 18;
        break;
      case 99:
        delta = 18;
        break;
      case 100:
        delta = 19;
        break;
      case 101:
        delta = 19;
        break;
      case 104:
        delta = 18;
        break;
      case 105:
        delta = 18;
        break;
      case 112:
        delta = 19;
        break;
      case 113:
        delta = 19;
        break;
      case 96:
        delta = 18;
        break;
      case 97:
        delta = 18;
        break;
      case 102:
        delta = 21;
        break;
      case 103:
        delta = 21;
        break;
      case 106:
        delta = 20;
        break;
      case 107:
        delta = 20;
        break;
      case 114:
        delta = 21;
        break;
      case 115:
        delta = 21;
        break;
      case 108:
        delta = 21;
        break;
      case 109:
        delta = 21;
        break;
      case 116:
        delta = 21;
        break;
      case 117:
        delta = 21;
        break;
      case 120:
        delta = 22;
        break;
      case 121:
        delta = 22;
        break;
      case 110:
        delta = 22;
        break;
      case 111:
        delta = 22;
        break;
      case 118:
        delta = 22;
        break;
      case 119:
        delta = 22;
        break;
      case 122:
        delta = 23;
        break;
      case 123:
        delta = 23;
        break;
      case 124:
        delta = 23;
        break;
      case 125:
        delta = 23;
        break;
      case 126:
        delta = 25;
        break;
      case 127:
        delta = 25;
        break;
    }

    digitrisk = hered * 1 + sedent * 2 + obesite * 4 + pregnant * 8;

    if (age < 30) {
      switch (digitrisk) {
        case 0:
          c1risk = 27;
          c2risk = 9;
          c3risk = 10;
          c4risk = 5;
          c5risk = 1;
          break;
        case 1:
          c1risk = 47;
          c2risk = 24;
          c3risk = 24;
          c4risk = 5;
          c5risk = 3;
          break;
        case 2:
          c1risk = 30;
          c2risk = 16;
          c3risk = 13;
          c4risk = 5;
          c5risk = 1;
          break;
        case 3:
          c1risk = 47;
          c2risk = 28;
          c3risk = 24;
          c4risk = 6;
          c5risk = 4;
          break;
        case 4:
          c1risk = 34;
          c2risk = 9;
          c3risk = 16;
          c4risk = 5;
          c5risk = 2;
          break;
        case 5:
          c1risk = 47;
          c2risk = 37;
          c3risk = 31;
          c4risk = 8;
          c5risk = 4;
          break;
        case 6:
          c1risk = 38;
          c2risk = 17;
          c3risk = 25;
          c4risk = 5;
          c5risk = 2;
          break;
        case 7:
          c1risk = 47;
          c2risk = 37;
          c3risk = 31;
          c4risk = 6;
          c5risk = 4;
          break;
        case 8:
          c1risk = 31;
          c2risk = 15;
          c3risk = 14;
          c4risk = 5;
          c5risk = 1;
          break;
        case 9:
          c1risk = 48;
          c2risk = 31;
          c3risk = 24;
          c4risk = 5;
          c5risk = 3;
          break;
        case 10:
          c1risk = 36;
          c2risk = 19;
          c3risk = 14;
          c4risk = 5;
          c5risk = 3;
          break;
        case 11:
          c1risk = 48;
          c2risk = 35;
          c3risk = 27;
          c4risk = 9;
          c5risk = 6;
          break;
        case 12:
          c1risk = 34;
          c2risk = 17;
          c3risk = 26;
          c4risk = 7;
          c5risk = 3;
          break;
        case 13:
          c1risk = 53;
          c2risk = 45;
          c3risk = 38;
          c4risk = 8;
          c5risk = 6;
          break;
        case 14:
          c1risk = 44;
          c2risk = 24;
          c3risk = 27;
          c4risk = 7;
          c5risk = 3;
          break;
        case 15:
          c1risk = 53;
          c2risk = 45;
          c3risk = 38;
          c4risk = 14;
          c5risk = 7;
          break;
      }
    }

    if (age >= 30 && age < 40) {
      switch (digitrisk) {
        case 0:
          c1risk = 35;
          c2risk = 18;
          c3risk = 14;
          c4risk = 6;
          c5risk = 3;
          break;
        case 1:
          c1risk = 50;
          c2risk = 34;
          c3risk = 25;
          c4risk = 7;
          c5risk = 4;
          break;
        case 2:
          c1risk = 38;
          c2risk = 19;
          c3risk = 16;
          c4risk = 6;
          c5risk = 3;
          break;
        case 3:
          c1risk = 50;
          c2risk = 38;
          c3risk = 27;
          c4risk = 10;
          c5risk = 6;
          break;
        case 4:
          c1risk = 35;
          c2risk = 23;
          c3risk = 26;
          c4risk = 6;
          c5risk = 5;
          break;
        case 5:
          c1risk = 51;
          c2risk = 41;
          c3risk = 41;
          c4risk = 10;
          c5risk = 6;
          break;
        case 6:
          c1risk = 38;
          c2risk = 17;
          c3risk = 25;
          c4risk = 5;
          c5risk = 2;
          break;
        case 7:
          c1risk = 52;
          c2risk = 41;
          c3risk = 41;
          c4risk = 16;
          c5risk = 10;
          break;
        case 8:
          c1risk = 39;
          c2risk = 20;
          c3risk = 16;
          c4risk = 6;
          c5risk = 3;
          break;
        case 9:
          c1risk = 52;
          c2risk = 39;
          c3risk = 31;
          c4risk = 9;
          c5risk = 5;
          break;
        case 10:
          c1risk = 40;
          c2risk = 26;
          c3risk = 20;
          c4risk = 6;
          c5risk = 5;
          break;
        case 11:
          c1risk = 52;
          c2risk = 44;
          c3risk = 31;
          c4risk = 12;
          c5risk = 9;
          break;
        case 12:
          c1risk = 37;
          c2risk = 25;
          c3risk = 26;
          c4risk = 7;
          c5risk = 5;
          break;
        case 13:
          c1risk = 53;
          c2risk = 49;
          c3risk = 41;
          c4risk = 10;
          c5risk = 6;
          break;
        case 14:
          c1risk = 48;
          c2risk = 32;
          c3risk = 28;
          c4risk = 8;
          c5risk = 6;
          break;
        case 15:
          c1risk = 53;
          c2risk = 51;
          c3risk = 41;
          c4risk = 22;
          c5risk = 13;
          break;
      }
    }

    if (age >= 40 && age < 50) {
      switch (digitrisk) {
        case 0:
          c1risk = 41;
          c2risk = 23;
          c3risk = 14;
          c4risk = 7;
          c5risk = 3;
          break;
        case 1:
          c1risk = 53;
          c2risk = 39;
          c3risk = 28;
          c4risk = 10;
          c5risk = 4;
          break;
        case 2:
          c1risk = 41;
          c2risk = 24;
          c3risk = 17;
          c4risk = 8;
          c5risk = 3;
          break;
        case 3:
          c1risk = 53;
          c2risk = 43;
          c3risk = 28;
          c4risk = 12;
          c5risk = 6;
          break;
        case 4:
          c1risk = 47;
          c2risk = 26;
          c3risk = 29;
          c4risk = 7;
          c5risk = 5;
          break;
        case 5:
          c1risk = 53;
          c2risk = 53;
          c3risk = 44;
          c4risk = 18;
          c5risk = 11;
          break;
        case 6:
          c1risk = 49;
          c2risk = 33;
          c3risk = 32;
          c4risk = 14;
          c5risk = 8;
          break;
        case 7:
          c1risk = 54;
          c2risk = 53;
          c3risk = 46;
          c4risk = 20;
          c5risk = 11;
          break;
        case 8:
          c1risk = 41;
          c2risk = 26;
          c3risk = 16;
          c4risk = 7;
          c5risk = 3;
          break;
        case 9:
          c1risk = 53;
          c2risk = 48;
          c3risk = 32;
          c4risk = 15;
          c5risk = 9;
          break;
        case 10:
          c1risk = 43;
          c2risk = 31;
          c3risk = 20;
          c4risk = 8;
          c5risk = 6;
          break;
        case 11:
          c1risk = 53;
          c2risk = 52;
          c3risk = 33;
          c4risk = 17;
          c5risk = 11;
          break;
        case 12:
          c1risk = 47;
          c2risk = 41;
          c3risk = 30;
          c4risk = 11;
          c5risk = 5;
          break;
        case 13:
          c1risk = 56;
          c2risk = 57;
          c3risk = 45;
          c4risk = 20;
          c5risk = 11;
          break;
        case 14:
          c1risk = 49;
          c2risk = 42;
          c3risk = 33;
          c4risk = 16;
          c5risk = 10;
          break;
        case 15:
          c1risk = 56;
          c2risk = 60;
          c3risk = 45;
          c4risk = 25;
          c5risk = 14;
          break;
      }
    }

    if (age >= 50) {
      switch (digitrisk) {
        case 0:
          c1risk = 42;
          c2risk = 30;
          c3risk = 16;
          c4risk = 9;
          c5risk = 3;
          break;
        case 1:
          c1risk = 55;
          c2risk = 53;
          c3risk = 34;
          c4risk = 23;
          c5risk = 8;
          break;
        case 2:
          c1risk = 44;
          c2risk = 32;
          c3risk = 23;
          c4risk = 12;
          c5risk = 5;
          break;
        case 3:
          c1risk = 55;
          c2risk = 54;
          c3risk = 35;
          c4risk = 24;
          c5risk = 9;
          break;
        case 4:
          c1risk = 49;
          c2risk = 42;
          c3risk = 29;
          c4risk = 14;
          c5risk = 7;
          break;
        case 5:
          c1risk = 55;
          c2risk = 65;
          c3risk = 47;
          c4risk = 23;
          c5risk = 11;
          break;
        case 6:
          c1risk = 50;
          c2risk = 48;
          c3risk = 33;
          c4risk = 14;
          c5risk = 8;
          break;
        case 7:
          c1risk = 55;
          c2risk = 66;
          c3risk = 47;
          c4risk = 27;
          c5risk = 14;
          break;
        case 8:
          c1risk = 42;
          c2risk = 34;
          c3risk = 20;
          c4risk = 12;
          c5risk = 8;
          break;
        case 9:
          c1risk = 55;
          c2risk = 59;
          c3risk = 37;
          c4risk = 27;
          c5risk = 14;
          break;
        case 10:
          c1risk = 44;
          c2risk = 39;
          c3risk = 25;
          c4risk = 15;
          c5risk = 11;
          break;
        case 11:
          c1risk = 55;
          c2risk = 59;
          c3risk = 37;
          c4risk = 29;
          c5risk = 18;
          break;
        case 12:
          c1risk = 47;
          c2risk = 45;
          c3risk = 30;
          c4risk = 16;
          c5risk = 8;
          break;
        case 13:
          c1risk = 56;
          c2risk = 65;
          c3risk = 48;
          c4risk = 34;
          c5risk = 19;
          break;
        case 14:
          c1risk = 50;
          c2risk = 50;
          c3risk = 34;
          c4risk = 22;
          c5risk = 15;
          break;
        case 15:
          c1risk = 56;
          c2risk = 66;
          c3risk = 48;
          c4risk = 38;
          c5risk = 25;
          break;
      }
    }
  }

  ageout = age + delta;

  if (ageout > 99) {
    ageout = 100;
  }

  return {
    idade: ageout,
    riscos: {
      c1risk,
      c2risk,
      c3risk,
      c4risk,
      c5risk,
    },
  };
}
